import { render, staticRenderFns } from "./SalesEvolutionChart.vue?vue&type=template&id=0d8b41ca&"
import script from "./SalesEvolutionChart.vue?vue&type=script&lang=js&"
export * from "./SalesEvolutionChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports